"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("source-map-support/register");

var _default = function _default() {
  return {
    name: 'head',
    synopsis: 'head [ITEM] ...[ITEMS]',
    description: 'Return items from the front of input',
    options: {
      n: {
        alias: 'number',
        type: 'number',
        description: 'Number of entries from the beginning of input to show',
        valid: function valid(value, args) {
          return value > 0 && value < args.length;
        },
        default: 1
      }
    },
    execute: function execute(args, _ref) {
      var number = _ref.number;
      return args.slice(0, number);
    }
  };
};

exports.default = _default;